import { useState } from "react";
import { supabase } from "./supabaseClient";
import "./BetaInterest.css";
import axios from "axios";

const API_BASE = "https://parentaibackend-production.up.railway.app";

export default function BetaInterest() {
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // 1. Save interest to Supabase
    const { error } = await supabase
      .from("beta_interest")
      .insert([
        {
          email,
          anxiety_profile: reason,
        },
      ]);

    if (error) {
      setLoading(false);
      console.error("Supabase insert error:", error);
      alert("Something went wrong. Please try again.");
      return;
    }

    // 2. Notify backend (invite pipeline)
    try {
      await axios.post(`${API_BASE}/beta/request-invite`, { email });
    } catch (err) {
      // Non-fatal: user still signed up
      setLoading(false);
      console.error("Backend invite error:", err?.response?.data || err);
      alert("Saved your signup, but email failed to send. Please try again.");
      return;
    }

    // 3. Done
    setLoading(false);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="beta-page">
        <div className="beta-card">
          <h2 className="beta-title">Thank you</h2>
          <p className="beta-lead">
            We’ve received your interest.  
            We’ll reach out if you’re a good fit for this beta.
          </p>
          <p className="beta-muted">
            Do check your JUNK / SPAM folder for the invite link.
          </p>
          <p className="beta-muted">
            TOFU is intentionally conservative and focused on reassurance — not
            diagnosis.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="beta-page">
      <div className="beta-card">
        {/* Hero */}
        <h1 className="beta-title">
          A calm companion for parents in moments of uncertainty
        </h1>
        <p className="beta-lead">
          Parenting decisions often happen when you’re tired, anxious, and
          unsure — especially at night.
        </p>

        {/* Value */}
        <div className="beta-value">
          <p>
            <strong>TOFU helps you decide</strong> what’s normal, what can wait,
            and what needs care — without overwhelming you with information.
          </p>
        </div>

        {/* What it is / is not */}
        <div className="beta-columns">
          <div className="beta-column">
            <h3>What TOFU is</h3>
            <ul>
              <li>A reassurance and triage companion</li>
              <li>A way to sanity-check your instincts</li>
              <li>A calm voice when care isn’t immediately available</li>
            </ul>
          </div>

          <div className="beta-column">
            <h3>What TOFU is not</h3>
            <ul>
              <li>A diagnostic tool</li>
              <li>A replacement for doctors</li>
              <li>Exhaustive medical explanations</li>
            </ul>
          </div>
        </div>

        {/* Form */}
        <div className="beta-form-section">
          <h3>Join the beta</h3>
          <p className="beta-muted">
            This beta focuses on whether TOFU reduces parental anxiety — not
            medical completeness.
          </p>

          <form onSubmit={handleSubmit} className="beta-form">
            <label>
              Email
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
              />
            </label>

            <label>
              When your child is unwell, which best describes you?
              <select
                required
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              >
                <option value="">Select one</option>
                <option value="unsure">
                  I often feel unsure and look for reassurance
                </option>
                <option value="confident">
                  I usually feel confident deciding what to do
                </option>
              </select>
            </label>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting…" : "Request beta access"}
            </button>
          </form>
        </div>

        <p className="beta-disclaimer">
          TOFU does not provide medical diagnosis or treatment.  
          If you are worried about your child, seek professional care.
        </p>
      </div>
    </div>
  );
}